import { trpcReact, trpcClient } from '@src/data/trpc';
import { queryClient } from './query';

const TRPCProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <trpcReact.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpcReact.Provider>
  );
};

export default TRPCProvider;
